export default "__VITE_ASSET__ee380c35__"